export default {
  methods: {
    setModifiers (baseClass) {
      let classes = []

      if (this.size) {
        classes.push(baseClass + this.size)
      }

      if (this.type) {
        classes.push(baseClass + this.type)
      }

      if (this.color) {
        classes.push(baseClass + this.color)
      }

      if (this.width && typeof this.width === 'string') {
        classes.push(baseClass + this.width)
      }

      return classes.join(' ')
    }
  }
}
